import React from 'react';

import Button from '@atlaskit/button';
import SectionMessage, {
  SectionMessageAction,
} from '@atlaskit/section-message';

import { StaticBanner } from '@qality/common-components/src/atoms/StaticBanner';

const DOCS_BUTTON_MESSAGE =
  'Upgrade to QAlity Plus to benefit from unlimited features.';

const openDocumentationPage = () => {
  window.open('https://soldevelo.atlassian.net/l/cp/9NteUgPf', '_blank');
};

type Props = {
  title: string;
  message?: string;
};

export function TopBanner({ title }: Props): JSX.Element {
  return (
    <StaticBanner appearance='warning'>
      <div>
        {`${title} `}
        <Button
          appearance='link'
          spacing='none'
          onClick={openDocumentationPage}
        >
          {DOCS_BUTTON_MESSAGE}
        </Button>
      </div>
    </StaticBanner>
  );
}

export function SectionBanner({ title, message }: Props): JSX.Element {
  return (
    <SectionMessage
      title={title}
      appearance='error'
      actions={[
        <SectionMessageAction
          onClick={openDocumentationPage}
          key='open-documentation-page'
        >
          {DOCS_BUTTON_MESSAGE}
        </SectionMessageAction>,
      ]}
    >
      {message && <p>{message}</p>}
    </SectionMessage>
  );
}
